import { render, staticRenderFns } from "./UserSearchForm.vue?vue&type=template&id=023420fa&"
import script from "./UserSearchForm.vue?vue&type=script&lang=ts&"
export * from "./UserSearchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports